import { styled } from '@vw-marketing/us-components';

export const UserContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Greeting = styled.div`
  margin-bottom: 2px;
`;

export const UserProfileContainer = styled.div`
  display: flex;
  align-items: start;
  gap: 24px;
  width: 100%;
  padding-bottom: ${({theme}) => theme.size.static400};
`;
